import { useEffect } from 'react';

/**
 * En el telefono las tablas (.data) se muestran como tarjetas: cada fila es
 * una tarjeta y cada celda lleva el nombre de su columna al lado (ver
 * global.css). Ese nombre sale del encabezado de la tabla; este componente
 * lo copia a cada celda como data-label, para no tener que escribirlo a
 * mano en cada una de las tablas del sistema. Vigila la pantalla y etiqueta
 * tambien las filas que llegan despues (filtros, paginas, modales).
 */
function etiquetar(raiz) {
  raiz.querySelectorAll('table.data').forEach((tabla) => {
    const titulos = [];
    tabla.querySelectorAll('thead tr:first-child th').forEach((th) => {
      const texto = th.textContent.trim();
      for (let i = 0; i < (th.colSpan || 1); i += 1) titulos.push(texto);
    });
    if (!titulos.length) return;
    tabla.querySelectorAll('tbody tr, tfoot tr').forEach((tr) => {
      let columna = 0;
      for (const celda of tr.children) {
        const titulo = titulos[columna] ?? '';
        if (celda.getAttribute('data-label') !== titulo) celda.setAttribute('data-label', titulo);
        columna += celda.colSpan || 1;
      }
    });
  });
}

export default function EtiquetasTablas() {
  useEffect(() => {
    let pendiente = 0;
    // Muchos cambios juntos (una tabla que se llena) se etiquetan una vez.
    const programar = () => {
      if (pendiente) return;
      pendiente = requestAnimationFrame(() => {
        pendiente = 0;
        etiquetar(document.body);
      });
    };
    etiquetar(document.body);
    // Solo mira nodos y texto, no atributos: poner data-label no lo dispara.
    const observador = new MutationObserver(programar);
    observador.observe(document.body, { childList: true, subtree: true, characterData: true });
    return () => {
      observador.disconnect();
      cancelAnimationFrame(pendiente);
    };
  }, []);
  return null;
}
